import { PrepareUrlProps } from '../interfaces';

export const prepareUrl = <TParams>({
  url,
  params,
}: PrepareUrlProps<TParams>) => {
  if (!params) return url;
  return `${url}?${new URLSearchParams(params as Record<string, string>)}`;
};
